<template>
    <el-dialog title="选择凭证" :visible.sync="isSwitch" width="1400px" :before-close="setSwitchClose">
        <div>
            <div class="content-head">
                <el-form :inline="true" class="demo-form-inline">
                    <el-form-item label="汇入银行">
                        <el-select v-model="argument.bankname" placeholder="请选择" class="el-select-mini" clearable>
                            <el-option v-for="item in Banknameopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="凭证类型">
                        <el-select v-model="argument.receipttype" placeholder="请选择" class="el-select-mini" clearable>
                            <el-option v-for="item in ReceiptTypeopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label=" 汇款单位">
                        <el-input v-model="argument.receiptcode" class="el-select-mini" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="汇款金额">
                        <el-input v-model="argument.receiptcount" class="el-select-mini" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="付款日期">
                        <el-date-picker v-model="argument.ReceiptPayDate" style="width: 120px" type="date" placeholder="选择日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getShowOrdersPaymentReceipt()" icon="el-icon-search" :loading="loadingBtn">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="Receiptinfo" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                <el-table-column width="34">
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.Receipt_ID_Show" :label="1" @input="handleRadioChange(scope.row)">{{ '' }}</el-radio>
                    </template>
                </el-table-column>
                <el-table-column width="80" prop="Receipt_ID" label="ID" align="center"></el-table-column>
                <el-table-column width="80" prop="Receipt_BankName" label="汇入银行" align="center"></el-table-column>
                <el-table-column width="80" prop="Receipt_Type" label="凭证类型" align="center"></el-table-column>
                <el-table-column prop="Receipt_Code" label="汇款单位" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" prop="Receipt_PayDate" label="付款日期" align="center"></el-table-column>
                <el-table-column width="100" prop="Receipt_Amount" label="汇款金额" align="center">
                    <template slot-scope="scope">￥{{ getFloat(scope.row.Receipt_Amount, 2) }}</template>
                </el-table-column>
                <el-table-column width="100" prop="Last_Amount" label="剩余金额" align="center">
                    <template slot-scope="scope">￥{{ getFloat(scope.row.Last_Amount, 2) }}</template>
                </el-table-column>
                <el-table-column width="150" prop="Receipt_Addtime" label="录入时间" align="center"></el-table-column>
                <el-table-column width="100" label="凭证附件" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="viewPaymentReceiptFile(scope.row.Payment_Receipt_File)">点击查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column width="180" prop="prop" label="本次分配金额" align="center">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.inputValue" @input="formatOnInput(scope.row)" @blur="valueBlur(scope.row)" placeholder="请输入分配金额" :disabled="scope.row.inputValuedisabled != 'false'"  style="width: 120px"></el-input>
                    </template>
                </el-table-column>
            </el-table>
             <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <div slot="footer" style="text-align: center">
            <el-button @click="setSwitchClose(false)">取 消</el-button>
            <el-button type="primary" @click="setSwitchClose(1)">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
export default {
    components: {
        Pagination
    },
    props: {
        isSwitch: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        isSwitch(newval, oldval) {
            if (newval) {
                this.initData();
            }
        }
    },
    data() {
        return {
            loadingBtn: false,
            argument: {
                bankname: '',
                receipttype: '',
                receiptcode: '',
                receiptcount: '',
                ReceiptPayDate: ''
            },
            Banknameopt: [],
            ReceiptTypeopt: [],
            Receiptinfo: [],
            // 添加分页配置
            paginationOptions: {
                Page: 1,
                total: 0,
                PageSize: 10
            },
            selectedRow: '' // 用于存储选中的行
        };
    },
    mounted() {
        this.initData();
        this.getShowOrdersPaymentReceipt();
    },
    methods: {
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getShowOrdersPaymentReceipt();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getShowOrdersPaymentReceipt();
        },
        setSwitchClose(e) {
            if (e != 1) {
                this.$emit('setSwitchClose', e);
                return;
            }
            let item = this.Receiptinfo.find((item) => item.Receipt_ID_Show == 1);
            if (!item) {
                return this.$message.error('请选择一条记录！');
            }
            if (item.inputValue > item.Last_Amount) {
                return this.$message.error('分款金额不可超过可用余额');
            }
            // if (!item.inputValue || item.inputValue == '0') {
            //     return this.$message.error('请输入分配金额再确认');
            // }
            this.$confirm('本次分款在满足条件时会自动审核通过，请确认付款凭证信息及本次分配金额是否准确！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
            })
                .then(async () => {
                    let jsonShowData = {};
                    jsonShowData.Receipt_ID = item.Receipt_ID;
                    jsonShowData.Receipt_Amount = item.Receipt_ID + '|' + String(item.inputValue).replace(',','');
                    this.$emit('setSwitchClose', e, jsonShowData);
                })
                .catch(() => {})
                .finally(() => {});
        },
        getShowOrdersPaymentReceipt() {
            this.loadingBtn = true;
            console.log(this.argument, 'this.argumentthis.argumentthis.argument');
            const json = JSON.stringify(this.argument);
            this.$newsApi.order
                .selectOrdersPaymentReceipt({ 
                    json: json,
                    Page: this.paginationOptions.Page,
                    PageSize: this.paginationOptions.PageSize
                })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.Receiptinfo = res.data.data;
                        this.Receiptinfo = this.Receiptinfo.map((item) => {
                            return {
                                ...item,
                                inputValue: 0,
                                Receipt_ID_Show: 0,
                                inputValuedisabled: 'false' // 默认可输入
                            };
                        });
                        // 更新总数
                        this.paginationOptions.total = res.data.total * this.paginationOptions.PageSize || 0;
                    } else {
                        this.Receiptinfo = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        async initData() {
            try {
                // 并行请求，减少等待时间
                const [res1, res2] = await Promise.all([this.$newsApi.common.getBankname(), this.$newsApi.common.getReceiptType()]);

                // 处理银行名称下拉框
                if (res1.data.Resultcode === 0) {
                    this.Banknameopt = Object.entries(res1.data.data).map(([key, value]) => {
                        return { value: Number(key), label: value };
                    });
                }
                // 处理收据类型下拉框
                if (res2.data.Resultcode === 0) {
                    this.ReceiptTypeopt = Object.entries(res2.data.data).map(([key, value]) => {
                        return { value: Number(key), label: value };
                    });
                }
            } catch (error) {
                console.error('获取订单收据信息时出错:', error);
            }
            console.log(this.Banknameopt, this.ReceiptTypeopt);
        },
        viewPaymentReceiptFile(url) {
            window.open(url, '_blank');
        },
        handleRadioChange(val) {
            this.Receiptinfo = this.Receiptinfo.map((item) => {
                return {
                    ...item,
                    Receipt_ID_Show: item.Receipt_ID == val.Receipt_ID ? 1 : 0,
                    inputValue: 0,
                    inputValuedisabled: item.Receipt_ID == val.Receipt_ID ? 'false' : '' // 默认可输入
                };
            });
        },
        formatOnInput(row) {
            row.inputValue = this.formatMoneyOnInput(row.inputValue);
        },
        valueBlur(row) {
            row.inputValue = this.formatMoneyOnBlur(row.inputValue);
        },
    }
};
</script>
